import * as React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const steps = [{
  number: "01",
  title: "Inspection",
  description: "We conduct a thorough, top-to-bottom inspection of your property to identify pest activity, entry points, and potential risks."
}, {
  number: "02",
  title: "Custom Plan",
  description: "Based on our findings, we develop a tailored treatment strategy designed specifically for your home and the unique pest challenges in Cape Coral."
}, {
  number: "03",
  title: "Targeted Treatment",
  description: "Our licensed technicians apply highly effective, targeted treatments to eliminate pests at the source while ensuring the safety of your family and pets."
}, {
  number: "04",
  title: "Follow-up",
  description: "We don't just treat and leave. We provide ongoing monitoring and follow-up services to ensure your property remains pest-free year-round."
}];
export default function PestControlProcess() {
  return <section id="pestcontrolprocess" className="bg-foreground py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-default text-primary-foreground mb-6 leading-tight">
            Our Proven Pest Control Process in <span className="text-background">Cape Coral</span>
          </h2>
          <p className="font-serif text-primary-foreground/80 text-lg">
            A systematic, four-step approach to completely eradicate pests and protect your property for the long term.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => <Card key={i} data-index={i} className="rounded-none shadow-none bg-transparent border-background/20 hover:border-background/60 transition-colors duration-300 text-primary-foreground flex flex-col h-full">
              <CardHeader className="pb-4">
                <div className="text-6xl font-default text-background mb-6 tracking-tighter">
                  {step.number}
                </div>
                <CardTitle className="text-2xl font-default text-primary-foreground">
                  {step.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="font-serif text-primary-foreground/70 leading-relaxed text-base">
                  {step.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}